export const initialState = {
  isPageEnabled: false,
  isMainFetching: true,
  isInquireFetching: false,
  canBuyInOneClick: false,
  inquireData: {
    discount: 0,
    total: 0,
  },
  groups: [
    // example data:
    //   {
    //     groupName: 'perfumeOfTheMonth',
    //     products: [ {}, {} ],
    //     price: 1000,
    //     discount: 495,
    //  }
  ],
}

export const setMainFetchingStatus = (state, payload) =>
  ({ ...state, isMainFetching: payload })

export const setCartFetchingStatus = (state, payload) =>
  ({ ...state, isCartFetching: payload })

export const setInquireFetchingStatus = (state, payload) =>
  ({ ...state, isInquireFetching: payload })

export const setMainData = (state, payload) =>
  ({ ...state, ...payload, isMainFetching: false })

export const setInquireData = (state, payload) =>
  ({ ...state, inquireData: payload, isInquireFetching: false })

export const setCanBuyInOneClickStatus = (state, payload) =>
  ({ ...state, canBuyInOneClick: payload })

export const reset = () => initialState
